import React, { useMemo, useRef } from "react";
import { View, StyleSheet } from "react-native";
import NtModalAccountPicker from "./NtModalAccountPicker";
import NtText from "../../components/NtText";
import NtTouchableEffect from "../../components/NtTouchableEffect";
import NtMaterialIcon from "../../components/NtMaterialIcon";
import NtModal from "../../components/NtModal";
import NtModalInputTitle from "../../components/NtModalInputTitle";
import NtAccountDisplay from "./NtAccountDisplay";
import { useTheme } from "../../context/ThemeContext";

function NtModalAccountPickerField({
  containerStyle,
  title,
  placeholder,
  value,
  setValue,
  removeOptions = [],
}) {
  const { theme } = useTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);
  const accountPickerRef = useRef(null);

  const renderAccountPickerModal = () => {
    return (
      <NtModal ref={accountPickerRef}>
        <NtModalAccountPicker
          removeOptions={removeOptions}
          defaultOpenTab={value?.name}
          defaultSelectedItem={value?.value}
          onCancel={() => {
            accountPickerRef.current?.dismiss();
          }}
          onPress={(selection) => {
            accountPickerRef.current?.dismiss();
            if (setValue) {
              setValue({
                name: selection?.name || selection?.tab?.id,
                value: selection?.value,
                item: selection?.item,
              });
            }
          }}
        />
      </NtModal>
    );
  };

  const hasValue = () => {
    return value && Object.keys(value)?.length > 0;
  };

  const renderValue = () => {
    if (hasValue()) {
      return (
        <View style={styles.valueRow}>
          <NtAccountDisplay item={value} />
        </View>
      );
    }
    return <NtText style={styles.placeholder}>{placeholder}</NtText>;
  };

  const renderClear = () => {
    if (!hasValue()) return null;
    return (
      <NtTouchableEffect
        onPress={() => {
          if (setValue) setValue(null);
        }}
      >
        <NtMaterialIcon name="delete" color={theme.red} size={16} />
      </NtTouchableEffect>
    );
  };

  return (
    <View style={[styles.container, containerStyle]}>
      <NtModalInputTitle style={{ marginLeft: 4, marginBottom: 4 }}>
        {title}
      </NtModalInputTitle>
      <NtTouchableEffect
        style={styles.field}
        onPress={() => accountPickerRef.current?.show()}
      >
        {renderValue()}
        {renderClear()}
      </NtTouchableEffect>
      {renderAccountPickerModal()}
    </View>
  );
}

const makeStyles = (t) =>
  StyleSheet.create({
    container: { marginBottom: 8 },
    field: {
      paddingHorizontal: 12,
      height: 38,
      backgroundColor: t.surface2,
      borderWidth: 1,
      borderColor: t.borderSoft,
      borderRadius: t.radius,
      flexDirection: "row",
      alignItems: "center",
    },
    valueRow: {
      flexDirection: "row",
      alignItems: "center",
      flex: 1,
    },
    placeholder: {
      flex: 1,
      fontSize: 13,
      fontWeight: "400",
      color: t.textMute,
    },
  });

export default NtModalAccountPickerField;
